import CryptoJS from 'crypto-js'

/**
 * 接口签名（全站唯一实现，services/request/sign.js 与 config/axios/sign.js 均从此处转发）
 *
 * 与后端 TokenAuthenticationFilter 的校验规则严格对应：
 *   明文 = '#' + appid + '#' + 'appid=..&nonce=..&timestamp=..'（key 升序、sign 自身不参与）
 *   签名 = AES-128-ECB/PKCS7(明文, appSecret) 的 Base64
 * 后端使用「租户配置里的 appSecret」（system_tenant.app_secret）校验，因此密钥轮换要两边同步。
 *
 * 安全说明：考生端是浏览器应用，构建产物里必然带得到密钥，无法做到真正保密；
 * 真正的约束在服务端（sign 校验 + token 鉴权 + 业务校验）。这里把密钥从源码常量改为
 * 「构建时环境变量优先、常量兜底」，便于运维在不改代码的情况下轮换密钥
 * （部署时注入 VUE_APP_SIGN_APPID / VUE_APP_SIGN_APPSECRET）。
 */
const appId = process.env.VUE_APP_SIGN_APPID || 'dwggptspw6xhpcei'
const appSecret = process.env.VUE_APP_SIGN_APPSECRET || '7kci4sruiktwx5fd'

export function signature() {
  const timestamp = new Date().getTime()
  const headers = new Map()
  headers.set('appid', appId)
  headers.set('timestamp', timestamp)
  headers.set('nonce', timestamp)

  let content = '#' + appId + '#'
  const sortedKeys = Array.from(headers.keys()).sort()
  for (const headerName of sortedKeys) {
    content += headerName + '=' + headers.get(headerName) + '&'
  }
  content = content.substring(0, content.length - 1)

  const key = CryptoJS.enc.Utf8.parse(appSecret)
  const srcs = CryptoJS.enc.Utf8.parse(content)
  const encrypted = CryptoJS.AES.encrypt(srcs, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return { appid: appId, timestamp: timestamp, sign: encrypted.toString(), nonce: timestamp }
}
